import { request } from 'utils/request';
import {
  IConfirmFieldUploadData,
  IGetFieldNotesPayload,
  IGetFieldPropertiesPayload,
  ISubmitImportFieldsFromSeasonPayload,
  IUpdateFieldInformationData,
} from './slice/types';

const fieldApi = {
  getFieldsById: (envId: number, shapeFileId: string) => {
    return request({
      url: `hiiko_environment/${envId}/fields/shape-file/${shapeFileId}/layer`,
    });
  },
  confirmFieldUpload: (envId: number, data: IConfirmFieldUploadData) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/fields/confirm-field-upload`,
      data,
    });
  },
  updateFieldInformation: (
    envId: number,
    data: IUpdateFieldInformationData,
  ) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/fields/update`,
      data,
    });
  },
  deleteFieldSeasonById: (envId: number, fieldId: number) => {
    return request({
      method: 'DELETE',
      url: `hiiko_environment/${envId}/field-seasons/${fieldId}`,
    });
  },

  updateFieldNote: ({
    envId,
    fieldId2,
    notes,
  }: {
    envId: number;
    fieldId2: number;
    notes: string;
  }) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/fields/${fieldId2}/note`,
      data: { note: notes },
    });
  },

  getFieldNote: ({ envId, fieldId2 }: IGetFieldNotesPayload) => {
    return request({
      url: `hiiko_environment/${envId}/fields/${fieldId2}/note`,
    });
  },

  getFieldProperties: ({ envId, fieldId2 }: IGetFieldPropertiesPayload) => {
    return request({
      url: `hiiko_environment/${envId}/fields/${fieldId2}/properties`,
    });
  },

  importFieldsFromSeason: ({
    envId,
    seasonId,
    ...data
  }: ISubmitImportFieldsFromSeasonPayload) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/seasons/${seasonId}/import`,
      data,
    });
  },
};

export default fieldApi;
